import React from "react";
import { IIndustry, ITopic } from "../../typings/filterEntities";
import FilterBar from "../FilterBar/FilterBar";
import styles from "./PageHero.module.css";

interface IProps {
  industries: IIndustry[];
  topics: ITopic[];
  filterBarRef?: React.RefObject<HTMLDivElement | null>;
}

export default function PageHero(props: IProps) {
  return (
    <section className={styles.root}>
      <div className={styles.filterBar}>
        <FilterBar {...props} location="pageHero" />
      </div>
    </section>
  );
}
